import { useQuery, UseQueryResult } from 'react-query';
import { api } from '../api';
import { useWorkpaperContext } from '../providers/WorkpaperProvider';
import { ReconciliationWorksheet, Worksheet } from '../types/worksheet';

type GetWorksheetsResponse = {
    worksheets: Worksheet[];
    totalItems: number;
    lastRefreshedAt?: Date;
};

type UseWorksheetsConfig = {
    filterQuery?: string;
    searchQuery?: string;
    sortQuery?: string;
    limit?: number;
    page: number;
    hasAccount?: boolean;
};

async function getWorksheets(
    workpaperId: string,
    { limit, page, filterQuery, searchQuery, sortQuery, hasAccount }: UseWorksheetsConfig
): Promise<GetWorksheetsResponse> {
    const query =
        process.env.REACT_APP_MOCK_API === 'true'
            ? `?filter=${filterQuery}&search=${searchQuery}&sort=${sortQuery}&limit=${limit}&page=${page}&hasAccount=${hasAccount}`
            : `?${filterQuery}&search=${searchQuery}&${sortQuery}&limit=${limit}&page=${page}&hasAccount=${hasAccount}`;
    const { data } = await api.get(`/workpapers/${workpaperId}/worksheets${query}`);
    return data;
}

export function useWorksheets(
    { limit, page, filterQuery, searchQuery, sortQuery, hasAccount }: UseWorksheetsConfig,
    overrideWorkpaperId?: string
): UseQueryResult<GetWorksheetsResponse> {
    const { id: contextWorkpaperId } = useWorkpaperContext();
    const workpaperId = overrideWorkpaperId || contextWorkpaperId;

    return useQuery(
        ['worksheets', workpaperId, limit, page, filterQuery, searchQuery, sortQuery, hasAccount],
        () => getWorksheets(workpaperId, { limit, page, filterQuery, searchQuery, sortQuery, hasAccount }),
        {
            enabled: filterQuery !== undefined && searchQuery !== undefined && sortQuery !== undefined,
            keepPreviousData: true,
        }
    );
}
